<template>
  <div>
    <DataTable
      v-model:filters="filters"
      v-model:expandedRows="expandedRows"
      :value="items"
      :loading="loading"
      :rows="10"
      :totalRecords="total"
      :rowsPerPageOptions="[10, 25, 50]"
      filterDisplay="row"
      dataKey="id"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Memuat {first} dari {last} data dari total {totalRecords}"
      class="p-datatable-sm"
      row-hover
      paginator
      scrollable
      lazy
      @page="onPage($event)"
      @sort="onSort($event)"
      @filter="onFilter($event)"
    >
      <template #empty>
        <div class="text-center">Tidak ada data.</div>
      </template>
      <template #loading>
        <div class="text-center">Memuat data, harap tunggu...</div>
      </template>
      <Column style="min-width: 3rem; flex: initial" header="" expander />
      <Column
        field="pp_no"
        header="No. Bukti"
        style="min-width: 15rem"
        headerStyle="min-width: 15rem"
        sortable
      >
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @keydown.enter="filterCallback()"
          />
        </template>
      </Column>
      <Column
        dataType="date"
        field="pp_at"
        filter-field="payment_between"
        header="Tanggal"
        style="min-width: 19rem"
        headerStyle="min-width: 19rem"
        sortable
      >
        <template #body="{ data }">
          {{ formatDate(data.pp_at) }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <CalendarFilter
            ref="calendarFilter"
            v-model="filterModel.value"
            @select="filterCallback()"
          />
        </template>
      </Column>
      <Column
        field="supplier.nama"
        sort-field="supplier"
        filter-field="supplier"
        header="Supplier"
        style="min-width: 19rem"
        headerStyle="min-width: 19rem"
        sortable
      >
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            v-model="filterModel.value"
            class="p-column-filter"
            @keydown.enter="filterCallback()"
          />
        </template>
      </Column>
      <Column field="pembayaran" header="Pembayaran" style="min-width: 22rem">
        <template #body="{ data }">
          <div>
            {{ data.pembayaran.toUpperCase() }}
            <span v-if="data.pembayaran === 'giro'">
              , No: {{ data.giro_no }}, Tgl. Jatuh Tempo:
              {{ formatDate(data.giro_at) }}
            </span>
            <!--<span v-if="data.settle_at">
              , Tgl. Bayar: {{ formatDate(data.settle_at) }}
            </span>-->
          </div>
        </template>
      </Column>
      <Column field="kas.nama" header="Kas/Bank" style="min-width: 7rem">
        <template #body="{ data }">
          <span v-if="data.kas.rekening">
            {{ data.kas.nama }}&nbsp;({{ data.kas.rekening }})
          </span>
          <span v-else>{{ data.kas.nama }}</span>
        </template>
      </Column>
      <!--<Column
        field="giro_status"
        filter-field="giro_status"
        header="Status"
        style="min-width: 6rem"
        headerStyle="min-width: 6rem"
      >
        <template #filter="{ filterModel, filterCallback }">
          <div class="field-checkbox p-column-filter">
            <Checkbox
              id="status-cair"
              v-model="filterModel.value"
              :binary="true"
              @change="filterCallback()"
            />
            <label for="status-cair">Cair</label>
          </div>
        </template>
        <template #body="{ data }">
          {{ formatDate(data.giro_status_at) }}
        </template>
      </Column>-->
      <Column
        field="jumlah"
        header="Total"
        type="numeric"
        style="min-width: 7rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.jumlah) }}
        </template>
      </Column>
      <Column
        field="jumlah_dibayar"
        header="Dibayar"
        type="numeric"
        style="min-width: 7rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.jumlah_dibayar) }}
        </template>
      </Column>
      <Column
        field="saldo"
        header="Sisa"
        type="numeric"
        style="min-width: 6rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.jumlah_saldo) }}
        </template>
      </Column>      
      <!--<Column
        field="jumlah_diskon"
        header="Diskon"
        type="numeric"
        style="min-width: 10rem; flex-grow: 1; justify-content: flex-end"
      >
        <template #body="{ data }">
          {{ formatCurrency(data.jumlah_diskon) }}
        </template>
      </Column>-->
      <Column
        style="
          display: flex;
          flex-grow: 1;
          justify-content: flex-end;
          min-width: 140px;
        "
      >
        <template #body="{ data }">
          <Button
            type="button"
            icon="pi pi-print"
            class="p-button-outlined p-button-secondary p-button-text mr-2"
            @click="$emit('print', data)"
          />
          <Button
            type="button"
            icon="pi pi-pencil"
            class="p-button-outlined p-button-secondary p-button-text"
            @click="$emit('edit', data)"
          />
        </template>
      </Column>
      <template #expansion="slotProps">
        <grid-pembayaran-kontra :items="slotProps.data.detail" />
      </template>
    </DataTable>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import { formatCurrency, formatDate } from '@/helpers'
import CalendarFilter from '@/components/CalendarFilter'
import GridPembayaranKontra from '@/components/pembelian/GridPembayaranKontra'

export default {
  components: {
    CalendarFilter,
    GridPembayaranKontra,
  },
  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    gridOptions: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      options: this.gridOptions,
      expandedRows: [],
      filters: {
        pp_no: { value: null, matchMode: FilterMatchMode.CONTAINS },
        payment_between: { value: null, matchMode: FilterMatchMode.CONTAINS },
        supplier: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    }
  },
  watch: {
    'options.filters'(value) {
      if (!value.payment_between.value) {
        this.$refs.calendarFilter.clearValueOnly()
      }
    },
  },
  methods: {
    onPage(e) {
      e.page = e.page + 1
      e.sortField = this.options.sortField
      e.sortOrder = this.options.sortOrder
      this.options = e
      this.loadData()
    },
    onSort(e) {
      this.options = e
      this.loadData()
    },
    onFilter() {
      this.options.page = 1
      this.options.filters = this.filters
      this.loadData()
    },
    loadData() {
      this.$emit('request', this.options)
    },
    formatCurrency(value, minDigit = 0, maxDigit = 0) {
      return formatCurrency(value, minDigit, maxDigit)
    },
    formatDate(value) {
      return formatDate(value)
    },
  },
}
</script>
